const ACCORDION_CLASS = {
  ACCORDION_CONTENT: 'js-accordion__content',
  ACCORDION_TRIGGER: 'js-accordion__trigger'
};
class Accordion {
  constructor(accordion) {
    this.accordion = accordion;
    this.accordionTrigger = this.accordion.querySelector(`.${ACCORDION_CLASS.ACCORDION_TRIGGER}`);
    this.accordionContent = this.accordion.querySelector(`.${ACCORDION_CLASS.ACCORDION_CONTENT}`);
    this.initAccordion();
  }
  initAccordion() {
    this.accordionTrigger.addEventListener('click', () => {
      const aria = this.accordionTrigger.getAttribute('aria-expanded') === 'false';
      this.accordion.classList.toggle('is-open');
      this.accordionTrigger.setAttribute('aria-expanded', aria);
      this.accordionContent.setAttribute('aria-hidden', !aria);
    });
  }
}
export default Accordion;